import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import Roman from 'roman-numerals';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { ALLGEMEINE_HINWEISE_FELDERNAME, ANTRAG_VERBUNDPARTNER } from '../../../../../../lib/constants/componentsPath';
import { ANTRAG_TYP, PLATZHALTER_TEXT, RUS_ERFORDERLICHKEIT } from '../../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { checkIfAnyRUSHasComment, checkIfSelectedRUSHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import RusErklaerungenGlobal, { getFormStrucRusErklaerungGlobal } from './content/RusErklaerungenGlobal';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import RUSErklaerungSchema from 'src/lib/paths/rus-selbsterklaerung_FULL_Paths.json';
import { getAntragstellerName, getVerbundPartnerName } from '../../../application-helper-function/AppHelperfunctions';
const P = Schema.attributes;
const RUS_P = RUSErklaerungSchema.attributes;

export const TreeStructureSelbstErklaerungRUSGlobal = (application: any, readOnly: boolean, allgemeineHinweisRUS: any) => {
	let treeNodes: TreeNodeType[] = [];

	const anzahlHinweis =
		get(allgemeineHinweisRUS, RUS_P.Hinweise.path, []).length > 0 ? get(allgemeineHinweisRUS, RUS_P.Hinweise.path, []).length : 0;

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const selbsterklaerungErforderlichkeit = get(
		application,
		P.Foerderprogramm.schema.attributes.Konfiguration_RUS_Selbsterklaerung_Erforderlichkeit.path,
		'',
	);
	const showRUSErklaerung = shouldShowRUSErklaerung(antragsTyp, selbsterklaerungErforderlichkeit);

	if (showRUSErklaerung) {
		const antragstellerName = getAntragstellerName(application);
		treeNodes = [
			{
				label: 'RUS-Selbsterklärung',
				content: <ApplicationHeading title='RUS-Selbsterklärung' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyRUSHasComment(readOnly, application),
				children: [
					...get(allgemeineHinweisRUS, RUS_P.Hinweise.path, []).map((ele: any, i: number) => ({
						label: `${Roman.toRoman(i + 1)}. ${get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Titel)}`,
						content: (
							<>
								<Box sx={{ mt: '1rem' }}>
									<Typography variant='h3' component={'h3'}>
										{get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Untertitel, '')}
									</Typography>
									<MarkdownRenderer markdown={get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Inhalt, '')} />
								</Box>
							</>
						),
					})),
					{
						label: `${Roman.toRoman(anzahlHinweis + 1)}. RUS-Erklärung: ${antragstellerName}`,
						content: (
							<RusErklaerungenGlobal
								unternehmenId={get(application, `${P.Antragstellende_Organisation.path}.id`)}
								unternehmenName={antragstellerName}
								hasComment={checkIfSelectedRUSHasComment(
									readOnly,
									application,
									get(application, `${P.Antragstellende_Organisation.path}.id`),
								)}
							/>
						),
						formStruc: getFormStrucRusErklaerungGlobal(application, get(application, `${P.Antragstellende_Organisation.path}.id`)),
						hasComment: checkIfSelectedRUSHasComment(readOnly, application, get(application, `${P.Antragstellende_Organisation.path}.id`)),
					},
					...get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
						const hasCommentRUSVerbundpartner = checkIfSelectedRUSHasComment(
							readOnly,
							application,
							get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`),
							get(ele, ANTRAG_VERBUNDPARTNER.PositionID),
						);

						const vPartnerName = getVerbundPartnerName(ele, i);

						return {
							label: `${Roman.toRoman(i + anzahlHinweis + 2)}. RUS-Erklärung: ${vPartnerName}`,
							content: (
								<RusErklaerungenGlobal
									unternehmenId={get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`)}
									positionId={get(ele, ANTRAG_VERBUNDPARTNER.PositionID)}
									unternehmenName={vPartnerName}
									hasComment={hasCommentRUSVerbundpartner}
								/>
							),
							formStruc: getFormStrucRusErklaerungGlobal(application, get(ele, `id`), get(ele, ANTRAG_VERBUNDPARTNER.PositionID)),
							hasComment: hasCommentRUSVerbundpartner,
						};
					}),
				],
			},
		];
	}

	return treeNodes;
};

function shouldShowRUSErklaerung(typ: string, erforderlichkeit: string) {
	if (erforderlichkeit === RUS_ERFORDERLICHKEIT.NichtErforderlich) return false;
	if (erforderlichkeit === RUS_ERFORDERLICHKEIT.InAntragUndSkizze) return true;
	if (typ === ANTRAG_TYP.Skizze) return erforderlichkeit === RUS_ERFORDERLICHKEIT.NurInSkizze;
	if (typ === ANTRAG_TYP.Antrag) return erforderlichkeit === RUS_ERFORDERLICHKEIT.NurImAntrag;

	return false;
}
